export default __webpack_public_path__ + "img/servicio-api.96857857.png";